import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LayoutsComponent } from './component/layouts/layouts.component';
import {LoguinGuard} from "./guard";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren:() => import('./auth/auth.module').then(m=>m.AuthModule)
  },
  {
    path: 'restaurant',
    component: LayoutsComponent,
    canActivate: [LoguinGuard],
    children: [
      {
        path: 'brand',
        loadChildren: () =>
          import('./component/product/brand/brand.module').then(
            (b) => b.BrandModule
          ),
      },
      {
        path: 'category',
        loadChildren: () =>
          import('./component/product/category/category.module').then(
            (c) => c.CategoryModule
          ),
      },
      {
        path: 'product',
        loadChildren: () =>
          import('./component/product/product/product.module').then(
            (p) => p.ProductModule
          ),
      },
      {
        path: 'table',
        loadChildren: () =>
          import('./component/sales/table/table.module').then(
            (s) => s.TableModule
          ),
      },
      {
        path: 'commands',
        loadChildren: () =>
          import('./component/sales/commands/commands.module').then(
            (s) => s.CommandsModule
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./component/sales/reports/reports.module').then(
            (r) => r.ReportsModule
          ),
      },

      {
        path: 'user',
        loadChildren: () =>
          import('./component/user/user/user.module').then((u) => u.UserModule),
      },
      {
        path: 'location',
        loadChildren: () =>
          import('./component/user/location/location.module').then(
            (u) => u.LocationModule
          ),
      },
      {
        path: 'shopping',
        loadChildren: () =>
        import('./component/shopping/shopping.module').then((u)=> u.ShoppingModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'auth/login',
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes), CommonModule],
  exports: [RouterModule],
})
export class AppRoutingModule {}
